import { DelaSportTab } from '@shared/sportsbook/util';

export const MINIMUM_URL_SEGMENTS = 2;

export const DELASPORT_TABS_MAP = [DelaSportTab.Live, DelaSportTab.Sports, DelaSportTab.PreMatch];
export const DELASPORT_KEY = 'delasport';
